import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import {UserDashboardService} from '../user-dashboard.service';

@Component({
    selector: 'app-confirm-password',
    templateUrl: './confirm-password.component.html',
    styleUrls: ['./confirm-password.component.scss'],
    standalone: false
})
export class ConfirmPasswordComponent implements OnInit {
  id
  constructor(private router: ActivatedRoute, private languageService: UserLanguageService, private userDashBoardService: UserDashboardService) { }

  ngOnInit(): void {
    this.id = this.router.snapshot.params['id']
    console.log("ID: ", this.id)
    this.userDashBoardService.verifyUserEmail(this.id)
    //this.updateUserField(this.id)
  }

  /*updateUserField(id){
    let docRef = this.db.firestore.collection('users').doc(id)
    docRef.update({emailVerified: true})
  }*/

}
